import React, { Fragment } from 'react';
import 'whatwg-fetch';
import AppProposalInput from './appProposalInput';
import hardwareIcon from '../../images/icons/hardware.svg';
import virtualIcon from '../../images/icons/virtual.svg';
import SubNavBar from '../components/SubNavBar';
import NewProductModal from './components/NewProductModal';
import { arrayMove, SortableContainer, SortableElement, SortableHandle } from 'react-sortable-hoc';
import { GrDrag as DragIcon } from '@react-icons/all-files/gr/GrDrag';
import BillingTotalMenu from 'src/scenes/appProposal/components/BillingTotalMenu';
import withAuth from 'src/hoc/withAuth';

const apiGetHardware = '/api/productReferenceHardware/';
const apiGetVirtual = '/api/productReferenceVirtual/';
const apiPropositionDocument = '/__api__/api/proposition/pdf/';
const apiPropositionPost = '/api/proposition/new/';
const apiDealShow = '/api/deal/show/';

const labelHardware = 'hardware';
const labelVirtual = 'virtual';

const DragHandle = SortableHandle(() => <DragIcon size={15} style={{ cursor: 'grab', marginRight: 5 }} />);

const SortableItem = SortableElement(
  ({
    position,
    label,
    value,
    data,
    extendedParent,
    resetFASRM,
    triggerFAS,
    triggerRM,
    triggerRA,
    activeFAS,
    activeRM,
    activeRA,
    marginFAS,
    marginRM,
    marginRA,
    applyMarginFAS,
    applyMarginRM,
    applyMarginRA,
    updateBaseTotal,
    updateTotal,
    updateWording,
    onDestroy,
    openToast,
  }) => {
    const inputKey = `${label}-${value.inputKey}`;

    return (
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <DragHandle />
        <AppProposalInput
          save={value.productReference ? value : undefined}
          id={inputKey}
          data={data}
          key={inputKey}
          extendedParent={extendedParent}
          resetFASRM={resetFASRM}
          triggerFAS={triggerFAS}
          triggerRM={triggerRM}
          triggerRA={triggerRA}
          activeFAS={activeFAS}
          activeRM={activeRM}
          activeRA={activeRA}
          marginFAS={marginFAS}
          marginRM={marginRM}
          marginRA={marginRA}
          applyMarginFAS={applyMarginFAS}
          applyMarginRM={applyMarginRM}
          applyMarginRA={applyMarginRA}
          updateBaseTotal={updateBaseTotal}
          updateTotal={updateTotal}
          updateWording={updateWording}
          onDestroy={() => onDestroy(value.inputKey)}
          openToast={openToast}
        />
      </div>
    );
  }
);

const SortableList = SortableContainer(
  ({
    items,
    label,
    data,
    extendedParent,
    resetFASRM,
    triggerFAS,
    triggerRM,
    triggerRA,
    activeFAS,
    activeRM,
    activeRA,
    marginFAS,
    marginRM,
    marginRA,
    applyMarginFAS,
    applyMarginRM,
    applyMarginRA,
    updateBaseTotal,
    updateTotal,
    updateWording,
    onDestroy,
    openToast,
  }) => {
    return (
      <div>
        {items.map((value, index) => (
          <SortableItem
            key={value.inputKey}
            index={index}
            data={data}
            value={value}
            label={label}
            position={index}
            extendedParent={extendedParent}
            resetFASRM={resetFASRM}
            triggerFAS={triggerFAS}
            triggerRM={triggerRM}
            triggerRA={triggerRA}
            activeFAS={activeFAS}
            activeRM={activeRM}
            activeRA={activeRA}
            marginFAS={marginFAS}
            marginRM={marginRM}
            marginRA={marginRA}
            applyMarginFAS={applyMarginFAS}
            applyMarginRM={applyMarginRM}
            applyMarginRA={applyMarginRA}
            updateBaseTotal={updateBaseTotal}
            updateTotal={updateTotal}
            updateWording={updateWording}
            onDestroy={onDestroy}
            openToast={openToast}
          />
        ))}
      </div>
    );
  }
);

class AppProposal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isMenuVisible: false,
      rowsTotal: {},
      rowHardwareInputs: [],
      rowVirtualInputs: [],
      isVirgin: true,
      entity: undefined,
      dataHardware: undefined,
      dataVirtual: undefined,
      modified: false,
      extended: false,
      docPrices: true,
      activeFAS: false,
      activeRM: false,
      activeRA: false,
      isNewProductModalOpened: false,
      newProductType: undefined,
      totalPDC: 0,
      totalFAS: 0,
      totalRM: 0,
      totalRA: 0,
      totalBaseFAS: 0,
      totalBaseRM: 0,
      totalBaseRA: 0,
      profitFAS: 0,
      profitRM: 0,
      profitRA: 0,
      marginFAS: 0,
      marginRM: 0,
      marginRA: 0,
      reducFAS: 0,
      reducRM: 0,
      reducRA: 0,
      leasing: false,
      leasingCost: 0,
      commitment: 12,
      proposalModelChoice: 'Centrex',
    };

    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.addInputHardware = this.addInputHardware.bind(this);
    this.addInputVirtual = this.addInputVirtual.bind(this);
    this.removeInputHardware = this.removeInputHardware.bind(this);
    this.removeInputVirtual = this.removeInputVirtual.bind(this);
    this.updateTotal = this.updateTotal.bind(this);
    this.updateBaseTotal = this.updateBaseTotal.bind(this);
    this.updateWording = this.updateWording.bind(this);
    this.toggleDoc = this.toggleDoc.bind(this);
    this.updatePDC = this.updatePDC.bind(this);
    this.triggerFAS = this.triggerFAS.bind(this);
    this.triggerRM = this.triggerRM.bind(this);
    this.resetFASRM = this.resetFASRM.bind(this);
    this.openDocument = this.openDocument.bind(this);
    this.getCurrentState = this.getCurrentState.bind(this);
    this.applyMarginFAS = this.applyMarginFAS.bind(this);
    this.applyMarginRM = this.applyMarginRM.bind(this);
    this.roundToTwo = this.roundToTwo.bind(this);
    this.toggleMenu = this.toggleMenu.bind(this);
  }

  handleInputChange(event) {
    const target = event.target;
    let value = target.value;
    const name = target.name;

    if (
      name === 'reducFAS' ||
      name === 'reducRM' ||
      name === 'marginFAS' ||
      name === 'marginRM' ||
      name === 'marginRA'
    ) {
      value = !isNaN(value) && value != '' ? parseFloat(value) : 0;
    } else if (name === 'leasing') {
      value = target.checked;
    }

    this.setState({
      [name]: value,
    });
  }

  componentDidMount() {
    if (this.props.match.params.id) {
      // check if id supplied in the route
      const paramsID = this.props.match.params.id;

      let queryURL = apiDealShow;
      let graphQL =
        '{ deal(id:' +
        paramsID +
        '){ id, name, stepProd{ intermediateStageNumber }, stepCommercial { id, intermediateStageNumber, proposition { id, modelType, quoteArticlesHardware{ id, quantity, position, commercialWording, accessCharges, basicAccessCharges, mensualRecurrency, basicMensualRecurrency, annualRecurrency, basicAnnualRecurrency, productReference{ id, wording, editable } }, quoteArticlesVirtual{ id, quantity, position, commercialWording, accessCharges, basicAccessCharges, mensualRecurrency, basicMensualRecurrency, annualRecurrency, basicAnnualRecurrency, productReference{ id, wording, editable } }, pdc, totalFAS, totalRM, totalRA, engagement, discountFAS, discountRM, discountRA, hasLeasing, leasingInterest } } } }';
      queryURL += graphQL;
      this.props
        .authFetch(queryURL, {
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
          },
          method: 'GET',
        })
        .then((resp) => resp.json())
        .then(
          function (data) {
            if (data['data']['deal']['stepCommercial']['proposition']) {
              // A proposal has already been saved
              let numRowHardware = 0;
              let numRowVirtual = 0;
              if (data['data']['deal']['stepCommercial']['proposition']['quoteArticlesHardware']) {
                const quotes = (
                  data['data']['deal']['stepCommercial']['proposition']['quoteArticlesHardware'] || []
                ).sort((a, b) => a.position - b.position);
                numRowHardware = 0;
                while (++numRowHardware <= quotes.length) {
                  this.addInputHardware(quotes[numRowHardware - 1]);
                }
              }
              if (data['data']['deal']['stepCommercial']['proposition']['quoteArticlesVirtual']) {
                const quotes = (
                  data['data']['deal']['stepCommercial']['proposition']['quoteArticlesVirtual'] || []
                ).sort((a, b) => a.position - b.position);
                numRowVirtual = 0;
                while (++numRowVirtual <= quotes.length) {
                  this.addInputVirtual(quotes[numRowVirtual - 1]);
                }
              }
              this.setState({
                isVirgin: false,
                entity: data['data']['deal']['stepCommercial']['proposition'],
                proposalModelChoice: data['data']['deal']['stepCommercial']['proposition']['modelType'] || 'Centrex',
                totalPDC: this.roundToTwo(data['data']['deal']['stepCommercial']['proposition']['pdc']),
                totalFAS: this.roundToTwo(data['data']['deal']['stepCommercial']['proposition']['totalFAS']),
                totalRM: this.roundToTwo(data['data']['deal']['stepCommercial']['proposition']['totalRM']),
                totalRA: this.roundToTwo(data['data']['deal']['stepCommercial']['proposition']['totalRA']),
                commitment: data['data']['deal']['stepCommercial']['proposition']['engagement'],
                reducFAS: parseInt(data['data']['deal']['stepCommercial']['proposition']['discountFAS']),
                reducRM: parseInt(data['data']['deal']['stepCommercial']['proposition']['discountRM']),
                reducRA: parseInt(data['data']['deal']['stepCommercial']['proposition']['discountRA']),
                leasing: data['data']['deal']['stepCommercial']['proposition']['hasLeasing'],
                leasingCost: data['data']['deal']['stepCommercial']['proposition']['leasingInterest'],
              });
            } else {
              // This is a new proposal -> we init blanks inputs
              this.addInputHardware();
              this.addInputVirtual();
            }
          }.bind(this)
        )
        .catch(
          function (error) {
            console.log(error);
          }.bind(this)
        );
    }
    ////////////////////////////////////////////////////////////
    let queryURL = apiGetHardware;
    let graphQL =
      '{ productReferencesHardware{ id, wording, commercialWording, accessCharges, mensualRecurrency, annualRecurrency, editable } }';
    queryURL += graphQL;
    this.props
      .authFetch(queryURL, {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        method: 'GET',
      })
      .then((resp) => resp.json())
      .then(
        function (data) {
          this.setState({
            dataHardware: data['data']['productReferencesHardware'],
          });
        }.bind(this)
      )
      .catch(
        function (error) {
          console.log('erreur fetch ref hardware list: \n' + error);
        }.bind(this)
      );
    ////////////////////////////////////////////////////////////
    let queryURL2 = apiGetVirtual;
    let graphQL2 =
      '{ productReferencesVirtual{ id, wording, commercialWording, accessCharges, mensualRecurrency, annualRecurrency, editable } }';
    queryURL2 += graphQL2;
    this.props
      .authFetch(queryURL2, {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        method: 'GET',
      })
      .then((resp) => resp.json())
      .then(
        function (data) {
          this.setState({
            dataVirtual: data['data']['productReferencesVirtual'],
          });
        }.bind(this)
      )
      .catch(
        function (error) {
          console.log('erreur fetch ref virtual list: \n' + error);
        }.bind(this)
      );
  }

  triggerFAS() {
    this.setState({
      activeFAS: true,
    });
  }

  triggerRM() {
    this.setState({
      activeRM: true,
    });
  }

  triggerRA = () => {
    this.setState({
      activeRA: true,
    });
  };

  resetFASRM() {
    this.setState({
      activeFAS: false,
      activeRA: false,
      activeRM: false,
    });
  }

  applyMarginFAS(value) {
    let floatValue = parseFloat(value);
    let res = floatValue + floatValue * (parseFloat(this.state.marginFAS) / 100.0);
    return res;
  }

  applyMarginRM(value) {
    let floatValue = parseFloat(value);
    return floatValue + floatValue * (parseFloat(this.state.marginRM) / 100.0);
  }

  applyMarginRA = (value) => {
    let floatValue = parseFloat(value);
    return floatValue + floatValue * (parseFloat(this.state.marginRA) / 100.0);
  };

  roundToTwo(num) {
    return +(Math.round(num + 'e+2') + 'e-2');
  }

  toggleMenu() {
    this.setState({
      isMenuVisible: !this.state.isMenuVisible,
    });
  }

  toggleNewProductModal = (newProductType) =>
    this.setState({ newProductType, isNewProductModalOpened: !this.state.isNewProductModalOpened });

  onNewProductCreated = (type, product) => {
    const newProducts = [...this.state[`data${type}`], product];

    this.setState({
      [`data${type}`]: newProducts,
      isNewProductModalOpened: false,
    });

    this.props.openToast(true, `${type === 'Hardware' ? 'Produit' : 'Service'} créé avec succès !`);
  };

  onHardwareSortEnd = ({ oldIndex, newIndex }) => {
    this.setState(({ rowHardwareInputs }) => ({
      rowHardwareInputs: arrayMove(rowHardwareInputs, oldIndex, newIndex),
    }));
  };

  onVirtualSortEnd = ({ oldIndex, newIndex }) => {
    this.setState(({ rowVirtualInputs }) => ({
      rowVirtualInputs: arrayMove(rowVirtualInputs, oldIndex, newIndex),
    }));
  };

  render() {
    // PDC = (total margin FAS) + (total margin RM * 12 months)
    const { data } = this.state;
    const proposalModels = {
      1: 'Centrex',
      2: 'Mobile',
      3: 'VPN',
      4: 'IPBX',
      5: 'Trunk',
      6: 'Informatique',
      7: 'Ajout/upgrad',
    };

    return (
      <div id='appView' className='appBilling div-entity'>
        <SubNavBar
          goBack={this.props.history.goBack}
          title='Proposition commerciale'
          actionButton={
            <Fragment>
              <select
                name='proposalModelChoice'
                value={this.state.proposalModelChoice ? this.state.proposalModelChoice : proposalModels[1]}
                onChange={this.handleInputChange}
                className='form-control'
              >
                {proposalModels ? (
                  Object.entries(proposalModels).map(([key, val]) => (
                    <option key={key} value={val}>
                      {val}
                    </option>
                  ))
                ) : (
                  <span>Chargement...</span>
                )}
              </select>
              <span>Prix unitaire </span>
              <label className='switch'>
                <input
                  defaultChecked={this.state.docPrices}
                  onChange={this.toggleDoc}
                  id='btnToggleBillingDoc'
                  type='checkbox'
                />
                <div className='slider round' />
              </label>
              <button onClick={this.openDocument} type='button' className='btn btn-sm btn-outline-success'>
                <span className='icon icon-document'>Afficher doc</span>
              </button>
            </Fragment>
          }
        />

        <div id='appViewContent' className='listRefScroll'>
          <div className='alignHorizontal panelAppViewCat'>
            <img src={hardwareIcon} />
            <h6>Produit</h6>

            <button onClick={() => this.addInputHardware()} type='button' className='btn btn-sm btn-primary mr-1'>
              <span className='icon icon-plus' />
              Ajouter
            </button>

            <button
              onClick={() => this.toggleNewProductModal('Hardware')}
              type='button'
              className='btn btn-sm btn-outline-primary'
            >
              <span className='icon icon-plus' />
              Créer
            </button>
          </div>

          <SortableList
            useDragHandle
            items={this.state.rowHardwareInputs}
            label={labelHardware}
            data={this.state.dataHardware}
            onSortEnd={this.onHardwareSortEnd}
            extendedParent={this.state.extended}
            resetFASRM={() => this.resetFASRM()}
            triggerFAS={() => this.triggerFAS()}
            triggerRM={() => this.triggerRM()}
            triggerRA={() => this.triggerRA()}
            activeFAS={this.state.activeFAS}
            activeRM={this.state.activeRM}
            activeRA={this.state.activeRA}
            marginFAS={this.state.marginFAS}
            marginRM={this.state.marginRM}
            marginRA={this.state.marginRA}
            applyMarginFAS={(value) => this.applyMarginFAS(value)}
            applyMarginRM={(value) => this.applyMarginRM(value)}
            applyMarginRA={(value) => this.applyMarginRA(value)}
            updateBaseTotal={this.updateBaseTotal}
            updateTotal={this.updateTotal}
            updateWording={this.updateWording}
            onDestroy={(inputKey) => this.removeInputHardware(inputKey)}
            openToast={this.props.openToast}
          />
          <hr />
          <div className='alignHorizontal panelAppViewCat'>
            <img src={virtualIcon} />
            <h6>Service</h6>

            <button onClick={() => this.addInputVirtual()} type='button' className='btn btn-sm btn-primary mr-1'>
              <span className='icon icon-plus' />
              Ajouter
            </button>

            <button
              onClick={() => this.toggleNewProductModal('Virtual')}
              type='button'
              className='btn btn-sm btn-outline-primary'
            >
              <span className='icon icon-plus' />
              Créer
            </button>
          </div>

          <SortableList
            useDragHandle
            items={this.state.rowVirtualInputs}
            label={labelVirtual}
            data={this.state.dataVirtual}
            onSortEnd={this.onVirtualSortEnd}
            extendedParent={this.state.extended}
            resetFASRM={() => this.resetFASRM()}
            triggerFAS={() => this.triggerFAS()}
            triggerRM={() => this.triggerRM()}
            triggerRA={() => this.triggerRA()}
            activeFAS={this.state.activeFAS}
            activeRM={this.state.activeRM}
            activeRA={this.state.activeRA}
            marginFAS={this.state.marginFAS}
            marginRM={this.state.marginRM}
            marginRA={this.state.marginRA}
            applyMarginFAS={(value) => this.applyMarginFAS(value)}
            applyMarginRM={(value) => this.applyMarginRM(value)}
            applyMarginRA={(value) => this.applyMarginRA(value)}
            updateBaseTotal={this.updateBaseTotal}
            updateTotal={this.updateTotal}
            updateWording={this.updateWording}
            onDestroy={(inputKey) => this.removeInputVirtual(inputKey)}
            openToast={this.props.openToast}
          />
        </div>
        {this.state.isMenuVisible ? (
          <BillingTotalMenu
            activeFAS={this.state.activeFAS}
            activeRM={this.state.activeRM}
            activeRA={this.state.activeRA}
            marginFAS={this.state.marginFAS}
            marginRM={this.state.marginRM}
            marginRA={this.state.marginRA}
            totalFAS={this.state.totalFAS}
            totalRM={this.state.totalRM}
            totalRA={this.state.totalRA}
            reducFAS={this.state.reducFAS}
            reducRM={this.state.reducRM}
            reducRA={this.state.reducRA}
            profitFAS={this.state.profitFAS}
            profitRM={this.state.profitRM}
            profitRA={this.state.profitRA}
            totalPDC={this.state.totalPDC}
            commitment={this.state.commitment}
            leasing={this.state.leasing}
            leasingCost={this.state.leasingCost}
            onSubmit={this.handleSubmit}
            triggerFAS={this.triggerFAS}
            triggerRM={this.triggerRM}
            triggerRA={this.triggerRA}
            resetFASRM={this.resetFASRM}
            toggleMenu={this.toggleMenu}
            onInputChange={this.handleInputChange}
          />
        ) : (
          <div onClick={this.toggleMenu} className={'float-button'}>
            <span className={'icon icon-calculator'} />
          </div>
        )}

        <NewProductModal
          open={this.state.isNewProductModalOpened}
          productType={this.state.newProductType}
          onClose={() => this.toggleNewProductModal(undefined)}
          onValidate={this.onNewProductCreated}
        />
      </div>
    );
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.match.params.id !== this.props.match.params.id) {
      // Route reloaded
      this.componentDidMount();
    }

    if (!(!isNaN(this.state.reducFAS) && this.state.reducFAS !== '')) {
      console.log('invalide');
    }
    if (!isNaN(this.state.reducFAS) && this.state.reducFAS !== '' && prevState.reducFAS != this.state.reducFAS) {
      let newTotalFAS = this.state.totalFAS;
      let newProfitFAS = newTotalFAS - this.state.totalBaseFAS - parseFloat(this.state.reducFAS);
      let newTotalRM = this.state.totalRM;
      let newProfitRM = newTotalRM - this.state.totalBaseRM - parseFloat(this.state.reducRM);
      let newTotalRA = this.state.totalRA;
      let newProfitRA = newTotalRA - this.state.totalBaseRA - parseFloat(this.state.reducRA);
      this.setState({
        totalFAS: this.roundToTwo(newTotalFAS),
        profitFAS: this.roundToTwo(newProfitFAS),
        totalRM: this.roundToTwo(newTotalRM),
        profitRM: this.roundToTwo(newProfitRM),
        totalRA: this.roundToTwo(newTotalRA),
        profitRA: this.roundToTwo(newProfitRA),
        totalPDC: this.updatePDC(
          this.state.totalBaseFAS,
          newTotalFAS - parseFloat(this.state.reducFAS),
          this.state.totalBaseRM,
          newTotalRM - parseFloat(this.state.reducRM),
          this.state.totalBaseRA,
          newTotalRA - parseFloat(this.state.reducRA)
        ),
      });
    }
    if (!isNaN(this.state.reducRM) && this.state.reducRM !== '' && prevState.reducRM != this.state.reducRM) {
      let newTotalFAS = this.state.totalFAS;
      let newProfitFAS = newTotalFAS - this.state.totalBaseFAS - parseFloat(this.state.reducFAS);
      let newTotalRM = this.state.totalRM;
      let newProfitRM = newTotalRM - this.state.totalBaseRM - parseFloat(this.state.reducRM);
      let newTotalRA = this.state.totalRA;
      let newProfitRA = newTotalRA - this.state.totalBaseRA - parseFloat(this.state.reducRA);
      this.setState({
        totalFAS: this.roundToTwo(newTotalFAS),
        profitFAS: this.roundToTwo(newProfitFAS),
        totalRM: this.roundToTwo(newTotalRM),
        totalRA: this.roundToTwo(newTotalRA),
        profitRM: this.roundToTwo(newProfitRM),
        profitRA: this.roundToTwo(newProfitRA),
        totalPDC: this.updatePDC(
          this.state.totalBaseFAS,
          newTotalFAS - parseFloat(this.state.reducFAS),
          this.state.totalBaseRM,
          newTotalRM - parseFloat(this.state.reducRM),
          this.state.totalBaseRA,
          newTotalRA - parseFloat(this.state.reducRA)
        ),
      });
    }
    if (!isNaN(this.state.reducRA) && this.state.reducRA !== '' && prevState.reducRA != this.state.reducRA) {
      let newTotalFAS = this.state.totalFAS;
      let newProfitFAS = newTotalFAS - this.state.totalBaseFAS - parseFloat(this.state.reducFAS);
      let newTotalRA = this.state.totalRA;
      let newProfitRA = newTotalRA - this.state.totalBaseRA - parseFloat(this.state.reducRA);
      let newTotalRM = this.state.totalRM;
      let newProfitRM = newTotalRM - this.state.totalBaseRM - parseFloat(this.state.reducRM);
      this.setState({
        totalFAS: this.roundToTwo(newTotalFAS),
        profitFAS: this.roundToTwo(newProfitFAS),
        totalRM: this.roundToTwo(newTotalRM),
        totalRA: this.roundToTwo(newTotalRA),
        profitRM: this.roundToTwo(newProfitRM),
        profitRA: this.roundToTwo(newProfitRA),
        totalPDC: this.updatePDC(
          this.state.totalBaseFAS,
          newTotalFAS - parseFloat(this.state.reducFAS),
          this.state.totalBaseRM,
          newTotalRM - parseFloat(this.state.reducRM),
          this.state.totalBaseRA,
          newTotalRA - parseFloat(this.state.reducRA)
        ),
      });
    }

    return true;
  }

  updateWording(key, wording) {
    let list = this.state.rowsTotal;

    if (!list || !(key in list)) {
      return;
    }

    list[key]['commercialWording'] = wording;

    this.setState({
      rowsTotal: list,
    });
  }

  updatePDC(newTotalBaseFAS, newTotalFAS, newTotalBaseRM, newTotalRM, newTotalBaseRA, newTotalRA) {
    let res =
      parseFloat(newTotalFAS) -
      parseFloat(newTotalBaseFAS) +
      (parseFloat(newTotalRM) - parseFloat(newTotalBaseRM)) * 12.0 +
      parseFloat(newTotalRA) -
      parseFloat(newTotalBaseRA);

    return this.roundToTwo(res);
  }

  updateTotal(key, refId, fas, baseFas, rm, baseRm, ra, baseRa, quantity) {
    // Called when there is an update inside a row
    let list = this.state.rowsTotal;

    if (!list || !(key in list)) {
      return;
    }

    // 1) Update the current object
    list[key].refId = refId;
    list[key].fas = parseFloat(fas);
    list[key].basicFas = parseFloat(baseFas);
    list[key].rm = parseFloat(rm);
    list[key].basicRm = parseFloat(baseRm);
    list[key].ra = parseFloat(ra);
    list[key].basicRa = parseFloat(baseRa);
    list[key].quantity = quantity;
    // 2) Totals calcul
    let newBaseTotalFAS = 0;
    let newBaseTotalRM = 0;
    let newBaseTotalRA = 0;
    let newTotalFAS = 0;
    let newTotalRM = 0;
    let newTotalRA = 0;

    let fasDebug = '';
    let fasBaseDebug = '';
    for (let key in list) {
      if (list.hasOwnProperty(key)) {
        if (list[key].refId != -1) {
          newBaseTotalFAS += parseFloat(list[key].basicFas) * parseFloat(list[key].quantity);
          fasBaseDebug += ' +' + parseFloat(list[key].fas) + '*' + parseFloat(list[key].quantity);
          fasDebug += ' +' + parseFloat(list[key].basicFas) + '*' + parseFloat(list[key].quantity);
          newBaseTotalRM += parseFloat(list[key].basicRm) * parseFloat(list[key].quantity);
          newBaseTotalRA += parseFloat(list[key].basicRa) * parseFloat(list[key].quantity);
          newTotalRM += parseFloat(list[key].rm) * parseFloat(list[key].quantity);
          newTotalRA += parseFloat(list[key].ra) * parseFloat(list[key].quantity);
          newTotalFAS += parseFloat(list[key].fas) * parseFloat(list[key].quantity);
        }
      }
    }
    // 3) Update
    /* console.log("calcul FAS: "+fasDebug);
        console.log("calcul BaseFAS: "+fasBaseDebug);
        console.log("newBaseTotalFAS: "+newBaseTotalFAS+" newTotalFAS: "+newTotalFAS);
        console.log("newBaseTotalRM: "+newBaseTotalRM+" newTotalRM: "+newTotalRM); */
    // 4) Reduc
    let reducFAS = !isNaN(this.state.reducFAS) && this.state.reducFAS !== '' ? parseFloat(this.state.reducFAS) : 0.0;
    let reducRM = !isNaN(this.state.reducRM) && this.state.reducRM !== '' ? parseFloat(this.state.reducRM) : 0.0;
    let reducRA = !isNaN(this.state.reducRA) && this.state.reducRA !== '' ? parseFloat(this.state.reducRA) : 0.0;
    this.setState({
      rowsTotal: list,
      totalBaseFAS: newBaseTotalFAS,
      totalBaseRM: newBaseTotalRM,
      totalBaseRA: newBaseTotalRA,
      totalFAS: newTotalFAS,
      totalRM: newTotalRM,
      totalRA: newTotalRA,
      profitFAS: this.roundToTwo(newTotalFAS - newBaseTotalFAS - reducFAS),
      profitRM: this.roundToTwo(newTotalRM - newBaseTotalRM - reducRM),
      profitRA: this.roundToTwo(newTotalRA - newBaseTotalRA - reducRA),
      totalPDC: this.updatePDC(
        newBaseTotalFAS,
        newTotalFAS - parseFloat(this.state.reducFAS),
        newBaseTotalRM,
        newTotalRM - parseFloat(this.state.reducRM),
        newBaseTotalRA,
        newTotalRA - parseFloat(this.state.reducRA)
      ),
    });
  }

  updateBaseTotal(
    key,
    refId,
    fas,
    rm,
    ra,
    savedQuantity = undefined,
    savedFAS = undefined,
    savedRM = undefined,
    savedRA = undefined,
    quoteId = null
  ) {
    // Called when a new row is set OR when a row is destroyed
    // 1) Base
    let object = {
      refId: refId,
      fas: parseFloat(fas),
      basicFas: parseFloat(savedFAS ? savedFAS : fas),
      rm: parseFloat(rm),
      ra: parseFloat(ra),
      basicRm: parseFloat(savedRM ? savedRM : rm),
      basicRa: parseFloat(savedRA ? savedRA : ra),
      quantity: savedQuantity ? savedQuantity : 1,
    };
    if (quoteId) {
      object['id'] = quoteId;
    }
    // 2) Totals calcul
    let list = this.state.rowsTotal;
    list[key] = object;
    let newBaseTotalFAS = 0;
    let newBaseTotalRM = 0;
    let newBaseTotalRA = 0;
    let newTotalFAS = 0;
    let newTotalRM = 0;
    let newTotalRA = 0;

    let fasDebug = '';
    let fasBaseDebug = '';
    for (let key in list) {
      if (list.hasOwnProperty(key)) {
        if (list[key].refId != -1) {
          newBaseTotalFAS += parseFloat(list[key].basicFas) * parseFloat(list[key].quantity);
          fasBaseDebug += ' +' + parseFloat(list[key].fas) + '*' + parseFloat(list[key].quantity);
          fasDebug += ' +' + parseFloat(list[key].basicFas) + '*' + parseFloat(list[key].quantity);
          newBaseTotalRA += parseFloat(list[key].basicRa) * parseFloat(list[key].quantity);
          newBaseTotalRM += parseFloat(list[key].basicRm) * parseFloat(list[key].quantity);
          newTotalRA += parseFloat(list[key].ra) * parseFloat(list[key].quantity);
          newTotalRM += parseFloat(list[key].rm) * parseFloat(list[key].quantity);
          newTotalFAS += parseFloat(list[key].fas) * parseFloat(list[key].quantity);
        }
      }
    }
    // 3) Update
    /* console.log("calcul FAS: "+fasDebug);
        console.log("calcul BaseFAS: "+fasBaseDebug);
        console.log("newBaseTotalFAS: "+newBaseTotalFAS+" newTotalFAS: "+newTotalFAS);
        console.log("newBaseTotalRM: "+newBaseTotalRM+" newTotalRM: "+newTotalRM); */
    // 4) Reduc
    let reducFAS = !isNaN(this.state.reducFAS) && this.state.reducFAS !== '' ? parseFloat(this.state.reducFAS) : 0.0;
    let reducRM = !isNaN(this.state.reducRM) && this.state.reducRM !== '' ? parseFloat(this.state.reducRM) : 0.0;
    let reducRA = !isNaN(this.state.reducRA) && this.state.reducRA !== '' ? parseFloat(this.state.reducRA) : 0.0;
    this.setState({
      rowsTotal: list,
      totalBaseFAS: newBaseTotalFAS,
      totalBaseRM: newBaseTotalRM,
      totalBaseRA: newBaseTotalRA,
      totalFAS: newTotalFAS,
      totalRM: newTotalRM,
      totalRA: newTotalRA,
      profitFAS: this.roundToTwo(newTotalFAS - newBaseTotalFAS - reducFAS),
      profitRM: this.roundToTwo(newTotalRM - newBaseTotalRM - reducRM),
      profitRA: this.roundToTwo(newTotalRA - newBaseTotalRA - reducRA),
      totalPDC: this.updatePDC(
        newBaseTotalFAS,
        newTotalFAS - parseFloat(this.state.reducFAS),
        newBaseTotalRM,
        newTotalRM - parseFloat(this.state.reducRM),
        newBaseTotalRA,
        newTotalRA - parseFloat(this.state.reducRA)
      ),
    });
  }

  getCurrentState() {
    let res = {
      proposition: {
        deal: {
          id: this.props.match.params.id,
        },
        docPrices: this.state.docPrices,
        totalFAS: this.state.totalFAS,
        totalRM: this.state.totalRM,
        totalRA: this.state.totalRA,
        discountFAS: this.state.reducFAS,
        discountRM: this.state.reducRM,
        discountRA: this.state.reducRA,
        pdc: this.state.totalPDC,
        engagement: this.state.commitment,
        hasLeasing: this.state.leasing,
        leasingInterest: this.state.leasingCost,
        quoteArticlesHardware: [],
        quoteArticlesVirtual: [],
        proposalModelChoice: this.state.proposalModelChoice,
      },
    };
    let list = this.state.rowsTotal;
    let indiceHardware = 0;
    let indiceVirtual = 0;
    for (let key in list) {
      if (list.hasOwnProperty(key)) {
        if (list[key].refId != -1) {
          if (key.indexOf(labelHardware) !== -1) {
            const position = this.state.rowHardwareInputs.findIndex(
              (value) => `${labelHardware}-${value.inputKey}` === key
            );
            res.proposition.quoteArticlesHardware[indiceHardware] = { ...list[key], position };
            indiceHardware++;
          } else if (key.indexOf(labelVirtual) !== -1) {
            const position = this.state.rowVirtualInputs.findIndex(
              (value) => `${labelVirtual}-${value.inputKey}` === key
            );
            res.proposition.quoteArticlesVirtual[indiceVirtual] = { ...list[key], position };
            indiceVirtual++;
          } else {
            console.log('unexpected reference');
          }
        }
      }
    }

    ((res.proposition || []).quoteArticlesHardware || []).sort((a, b) => a.position - b.position);
    ((res.proposition || []).quoteArticlesVirtual || []).sort((a, b) => a.position - b.position);

    return res;
  }

  handleSubmit() {
    let json = this.getCurrentState();
    let queryURL = apiPropositionPost;
    let data = 'data=' + encodeURIComponent(JSON.stringify(json));
    this.props
      .authFetch(queryURL, {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        method: 'POST',
        body: data,
      })
      .then((resp) => resp.json())
      .then((data) => {
        if (data['isValid']) {
          this.props.openToast(true, 'Proposition sauvegardée');
          this.props.history.push('/dashboard/deal/' + this.props.match.params.id);
        } else {
          this.props.openToast(false, data.detail || data['error'] || 'Erreur sauvegarde proposition');
        }
      })
      .catch((error) => {
        this.props.openToast(false, error.message || 'Erreur sauvegarde proposition');
      });
  }

  openDocument() {
    let url = apiPropositionDocument;

    let form = document.createElement('form');
    form.method = 'POST';
    form.action = url;
    form.target = '_blank';

    let input = document.createElement('input');
    input.type = 'hidden';
    input.name = 'proposalEntry';
    input.value = JSON.stringify(this.getCurrentState());
    form.appendChild(input);
    document.body.appendChild(form);
    form.submit();
  }

  toggleDoc() {
    let value = this.state.docPrices ? false : true;
    this.setState({
      docPrices: value,
    });
  }

  addInputHardware(quote = undefined) {
    let newInput = this.state.rowHardwareInputs || [];
    newInput.push({ position: newInput.length, ...quote, inputKey: Date.now() });
    this.setState({
      rowHardwareInputs: newInput,
    });
  }

  addInputVirtual(quote = undefined) {
    let newInput = this.state.rowVirtualInputs || [];
    newInput.push({ position: newInput.length, ...quote, inputKey: Date.now() });
    this.setState({
      rowVirtualInputs: newInput,
    });
  }

  removeInputHardware(key) {
    this.setState({ rowHardwareInputs: this.state.rowHardwareInputs.filter((row) => row.inputKey !== key) });
  }

  removeInputVirtual(key) {
    this.setState({ rowVirtualInputs: this.state.rowVirtualInputs.filter((row) => row.inputKey !== key) });
  }
}

export default withAuth(AppProposal);
